module.exports = {"id":"199833","name":"Lars Unnerstall","rating":"73","photo":"./data/images/photos/1/199833.png","club":{"name":"VVV-Venlo","logo":"./data/images/clubs/VVV-Venlo.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LarsUnnerstall0.json
// module id = 2428
// module chunks = 0